export function formatPercentDisplay(rate: number | undefined): string {
  if (rate == null || Number.isNaN(rate)) return '0%';
  const n = rate <= 1 && rate >= 0 ? Math.round(rate * 100) : Math.round(rate);
  return `${n}%`;
}
